import React from 'react';

/** Section icon beside the "Authorization" heading in the work order editor. */
const AuthorizationSectionSvg = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 21.9981H3.00004L3 3.5H7.00004M15 3.5H19V14" stroke="#006CDD" strokeWidth="2" strokeLinecap="square" />
        <path
            d="M13.5 2H8.5C7.67157 2 7 2.67157 7 3.5C7 4.32843 7.67157 5 8.5 5H13.5C14.3284 5 15 4.32843 15 3.5C15 2.67157 14.3284 2 13.5 2Z"
            fill="#006CDD"
            stroke="#006CDD"
            strokeWidth="2"
            strokeLinecap="square"
        />
        <path d="M7 15H10.4286M7 11H15" stroke="#006CDD" strokeWidth="2" strokeLinecap="square" />
        <path d="M21 17L16 22L14 20" stroke="#006CDD" strokeWidth="2" strokeLinecap="square" />
    </svg>
);

export default AuthorizationSectionSvg;
